import { useMemo } from 'react';

import { isString } from '@app/common/utils';

import { normilizePatternLength } from './utils';

export const useNormilizePattern = (pattern: string | null, mask: string | null) => {
  const normilizePattern = useMemo(() => {
    if (isString(pattern) && isString(mask)) {
      return normilizePatternLength(pattern, mask);
    }

    return pattern;
  }, [pattern, mask]);

  return normilizePattern || '';
};
